import { Component, Input, OnInit } from '@angular/core';
import { schoolData } from 'src/app/core/models/schoolData';
import { ReadingSettingsDataService } from 'src/app/core/services/commonServices/reading-settings-data.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  constructor(private readingSettingsData: ReadingSettingsDataService) { }
  doaminName: string = this.readingSettingsData.getSchoolDomain();
  @Input() schoolData = new schoolData();
  ngOnInit(): void {
  }

}
